'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectIntl = connectIntl;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _constants = require('./constants');

var _injectIntl = require('./injectIntl');

var _injectIntl2 = _interopRequireDefault(_injectIntl);

var _createMapStateToProps = require('./createMapStateToProps');

var _createMapStateToProps2 = _interopRequireDefault(_createMapStateToProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function connectIntl(connect) {
  var mapStateToProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _createMapStateToProps2.default)();

  if (!connect) {
    !false ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, _constants.LOG_NAME + ' missing argument 1: "connect" in connectIntl') : (0, _invariant2.default)(false) : void 0;
    return function () {
      return null;
    };
  }

  var injector = (0, _injectIntl2.default)(connect, mapStateToProps);

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return function (Component) {
      return connect.apply(undefined, args)(injector(Component));
    };
  };
}

exports.default = connectIntl;


//////////////////
// WEBPACK FOOTER
// ./~/redux-intl-connect/lib/connectIntl.js
// module id = 325
// module chunks = 0